import {
    COLUMNELEMENT,
    EMPLOYEELISTBLOCK,
    FAQBLOCK,
    INFOBLOCK,
    LINKBLOCKCONTAINER,
    LISTELEMENT,
    QUOTATIONBLOCK,
    SLIDESHOW,
    STICKYBLOCK,
    TEXTBLOCK,
    VIDEOBLOCK,
    VIDEOLISTBLOCK
} from "Consts/blockTypes";
import {
    ArticleBlock,
    ColumnBlock,
    EmployeeListBlock,
    FAQBlock,
    InfoBlock,
    LinkBlockContainer,
    QuotationBlock,
    SlideShow,
    StickyBlock,
    TextBlock,
    VideoBlock,
    VideoListBlock
} from "Blocks";
import React from "react";

const MapBlocksToComponents = (blocks) => {
    let blocksToReturn = [];
    blocks.map((block, i) => {
        let component = GetBlock(block, i);
        if (component !== undefined) {
            blocksToReturn.push(component);
        }
    });
    return blocksToReturn;
};

let GetBlock = (model, i) => {
    const {Alias} = model;
    switch (Alias) {
        case LISTELEMENT:
            return <ArticleBlock {...model} key={`block-${i}`}/>;
        case QUOTATIONBLOCK:
            return <QuotationBlock {...model} key={`block-${i}`}/>;
        case EMPLOYEELISTBLOCK:
            return <EmployeeListBlock {...model} key={`block-${i}`}/>;
        case VIDEOLISTBLOCK:
            return <VideoListBlock {...model} key={`block-${i}`}/>;
        case VIDEOBLOCK:
            return <VideoBlock {...model} key={`block-${i}`}/>;
        case LINKBLOCKCONTAINER:
            return <LinkBlockContainer {...model} key={`block-${i}`}/>;
        case TEXTBLOCK:
            return <TextBlock {...model} key={`block-${i}`}/>;
        case COLUMNELEMENT:
            return <ColumnBlock {...model} key={`block-${i}`}/>;
        case FAQBLOCK:
            return <FAQBlock {...model} key={`block-${i}`}/>;
        case INFOBLOCK:
            return <InfoBlock {...model} key={`block-${i}`}/>;
        case STICKYBLOCK:
            return <StickyBlock {...model} key={`block-${i}`}/>;
        case SLIDESHOW:
            return <SlideShow {...model} key={`block-${i}`}/>;
        default:
            break;
    }
};

export default MapBlocksToComponents;
